import React, { useState } from 'react';
import i18next from 'i18next';
import { Tabs, Tab, Container, Typography, Box } from '@mui/material';

import GeneralInfo from './companyTabs/GeneralInfo';
import Members from './companyTabs/Members';
import ContactCandidate from './companyTabs/ContactCandidate';
import WhiteLabel from './companyTabs/WhiteLabel';
import Settings from './companyTabs/Settings';

const t = (i18nKey, params) => i18next.t(`userDashboard.company.${i18nKey}`, params);

const Company = () => {
    const [activeTab, setActiveTab] = useState('general');

    const renderContent = () => {
        switch (activeTab) {
            case 'general':
                return <GeneralInfo />;
            case 'members':
                return <Members />;
            case 'contact':
                return <ContactCandidate />;
            case 'whiteLabel':
                return <WhiteLabel />;
            case 'settings':
                return <Settings />;
            default:
                return <GeneralInfo />;
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <section id="company_dashboard" className='home'>
            <Container>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab label={t('tabs.general')} value="general" />
                    <Tab label={t('tabs.members')} value="members" />
                    <Tab label={t('tabs.whiteLabel')} value="whiteLabel" />
                    <Tab label={t('tabs.settings')} value="settings" />
                </Tabs>
                <Box mt={3}>
                    {renderContent()}
                </Box>
            </Container>
        </section>
    );
};

export default Company;